import * as types from '../store/mutation-types';

const state = {
    loginFailed: false,
    tokenExpired: false
};

const getters = {
    loginFailed: state => state.loginFailed,
    tokenExpired: state => state.tokenExpired
};

const actions = {
    loginFailed(context) {
        context.commit(types.SET_LOGIN_FAILED, true);
    },

    resetLoginMessages(context) {
        context.commit(types.SET_LOGIN_FAILED, false);
        context.commit(types.TOKEN_EXPIRED, false);
    },

    tokenExpired(context) {
        context.commit(types.TOKEN_EXPIRED, true);
    }
};

const mutations = {
    [types.SET_LOGIN_FAILED](state, bool) {
        state.loginFailed = bool;
    },

    [types.TOKEN_EXPIRED](state, bool) {
        state.tokenExpired = bool;
    }
};

const namespaced = true;

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced
};
